<template>
  <span v-if="source" class="badge" :class="`badge-${badgeType}`">
    {{ label }}
  </span>
</template>

<script>
import { sourceLabel, sourceVariant } from '@/util/customFieldSource'

// Map the variants defined in customFieldSource.js onto the global .badge type names.
const VARIANT_TO_BADGE_TYPE = {
  primary: 'primary',
  info: 'info',
  neutral: 'default',
}

export default {
  name: 'custom-field-source-badge',
  props: {
    source: {
      type: String,
      default: '',
    },
  },
  computed: {
    label() {
      return sourceLabel(this.source)
    },
    badgeType() {
      return VARIANT_TO_BADGE_TYPE[sourceVariant(this.source)] || 'default'
    },
  },
}
</script>
